import { render, staticRenderFns } from "./Member2.vue?vue&type=template&id=494214d4&scoped=true"
import script from "./Member2.vue?vue&type=script&lang=js"
export * from "./Member2.vue?vue&type=script&lang=js"
import style0 from "./Member2.vue?vue&type=style&index=0&id=494214d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494214d4",
  null
  
)

export default component.exports